import React from 'react';
import NFoodprintCalculator from './components/NFootprintCalculator';
import './App.css';

function App() {
  return (
    <div className="App">
      <NFoodprintCalculator />
    </div>
  );
}

export default App;